import { MenuRoute } from '../../shared/menu/menu-route.model';

/**
 * Menu-eligible routes exposed by the Bank Reconciliation module.
 */
export const BANK_RECONCILIATION_MENU_ROUTES: MenuRoute[] = [
  {
    path: '/bank-reconciliation/dashboard',
    labelKey: 'BankReconciliation.dashboard',
    icon: '/assets/tablerIcons/outline/layout-dashboard.svg',
    moduleId: 42,
    groupLabelKey: 'MenuRoutes.group.bankReconciliationOverview'
  },
  {
    path: '/bank-reconciliation/accounts',
    labelKey: 'BankReconciliation.accounts',
    icon: '/assets/tablerIcons/outline/wallet.svg',
    moduleId: 42,
    groupLabelKey: 'MenuRoutes.group.bankReconciliationOverview'
  },
  {
    path: '/bank-reconciliation/companies',
    labelKey: 'BankReconciliation.companies',
    icon: '/assets/tablerIcons/outline/building.svg',
    moduleId: 42,
    groupLabelKey: 'MenuRoutes.group.bankReconciliationOverview'
  },
  {
    path: '/bank-reconciliation/intercompany',
    labelKey: 'BankReconciliation.intercompany',
    icon: '/assets/tablerIcons/outline/transfer.svg',
    moduleId: 42,
    groupLabelKey: 'MenuRoutes.group.bankReconciliationIntercompany'
  },
  {
    path: '/bank-reconciliation/intercompany/consolidated',
    labelKey: 'BankReconciliation.intercompanyConsolidated',
    icon: '/assets/tablerIcons/outline/chart-arcs.svg',
    moduleId: 42,
    groupLabelKey: 'MenuRoutes.group.bankReconciliationIntercompany'
  },
  {
    path: '/bank-reconciliation/kai-metrics',
    labelKey: 'BankReconciliation.kaiMetrics',
    icon: '/assets/tablerIcons/outline/sparkles.svg',
    moduleId: 42,
    groupLabelKey: 'MenuRoutes.group.bankReconciliationKai'
  },
  {
    path: '/bank-reconciliation/rules',
    labelKey: 'BankReconciliation.rules',
    icon: '/assets/tablerIcons/outline/adjustments.svg',
    moduleId: 42,
    groupLabelKey: 'MenuRoutes.group.bankReconciliationConfig'
  },
  {
    path: '/bank-reconciliation/schedule',
    labelKey: 'BankReconciliation.schedule',
    icon: '/assets/tablerIcons/outline/calendar-time.svg',
    moduleId: 42,
    groupLabelKey: 'MenuRoutes.group.bankReconciliationConfig'
  },
  {
    path: '/bank-reconciliation/access',
    labelKey: 'BankReconciliation.access.title',
    icon: '/assets/tablerIcons/outline/lock.svg',
    moduleId: 42,
    groupLabelKey: 'MenuRoutes.group.bankReconciliationConfig',
    requiresAdmin: true
  }
];
